module.exports = __webpack_public_path__ + "static/media/p_webmoney.7dde945f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pay/p_webmoney.png
// module id = 2441
// module chunks = 7